import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { AGENT_WANTAD_KEY } from "../constants/common";
import { pageURLs } from "@/constants";

const AgentCreateOrEditWantAdDraftListing = () => {
  useState(() => localStorage.removeItem(AGENT_WANTAD_KEY));
  return <Navigate to={pageURLs.agentCreatewantad} replace />;
};

export default AgentCreateOrEditWantAdDraftListing;
